import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { USER_CREATE } from '../apollo/user/userMutation';
import { toast } from 'react-toastify'; //? React-Toastify

const singupObject = {
  name: '',
  email: '',
  phone: '',
  gender: '',
  age: '',
  password: '',
  confirmPassword: '',
};

export default function Signup() {
  const navigate = useNavigate();

  const [signUp, setSignUp] = useState(singupObject);

  const handleChangeUser = (e) => {
    setSignUp((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  /**
   * ! CREATE_USER : Apollo-Graphql Implementation
   */
  const [UserCreate] = useMutation(USER_CREATE, {
    onError: (error) => {
      toast.error(error?.message);
    },
    onCompleted: ({ userCreate }) => {
      if (userCreate?.status === 201) {
        toast.success(userCreate?.message);

        //! navigate to Login page
        navigate('/login');
      }
    },
  });

  const handleSubmitUser = (e) => {
    e.preventDefault();

    UserCreate({
      variables: {
        input: {
          name: signUp.name,
          email: signUp.email,
          phone: signUp.phone,
          gender: signUp.gender.toUpperCase(),
          age: parseInt(signUp.age),
          password: signUp.password,
          confirmPassword: signUp.confirmPassword,
        },
      },
    });
  };

  //? #################################################
  return (
    <div
      className='modal modal-signin position-static d-block bg-secondary py-5'
      tabIndex='-1'
      role='dialog'
      id='modalSignin'
    >
      <div className='modal-dialog' role='document'>
        <div className='modal-content rounded-5 shadow'>
          {/* <div className='modal-header p-5 pb-4 border-bottom-0 '> */}
          <h2 className='text-center my-3'>
            <strong>Create an Account</strong>
          </h2>
          <p className='text-center'>Welcome to Quote Website</p>
          {/* </div> */}
          <div className='modal-body p-5 pt-0'>
            <form className=''>
              <div className='form-floating mb-3'>
                <input
                  type='text'
                  className='form-control rounded-4'
                  id='floatingInput'
                  placeholder='Name'
                  name='name'
                  onChange={handleChangeUser}
                  value={signUp.name}
                  required
                />
                <label htmlFor='floatingInput'>Name</label>
              </div>
              <div className='form-floating mb-3'>
                <input
                  type='email'
                  className='form-control rounded-4'
                  id='floatingInput1'
                  placeholder='email'
                  name='email'
                  onChange={handleChangeUser}
                  value={signUp.email}
                  required
                />
                <label htmlFor='floatingInput1'>Email address</label>
              </div>
              <div className='form-floating mb-3'>
                <input
                  type='text'
                  className='form-control rounded-4'
                  id='floatingInput2'
                  placeholder='Phone Number'
                  name='phone'
                  onChange={handleChangeUser}
                  value={signUp.phone}
                  required
                />
                <label htmlFor='floatingInput2'>Phone Number</label>
              </div>
              <div className='form-floating mb-3'>
                <input
                  type='email'
                  className='form-control rounded-4'
                  id='floatingInput3'
                  placeholder='Gender'
                  name='gender'
                  onChange={handleChangeUser}
                  value={signUp.gender}
                  required
                />
                <label htmlFor='floatingInput3'>Gender</label>
              </div>
              <div className='form-floating mb-3'>
                <input
                  type='email'
                  className='form-control rounded-4'
                  id='floatingInput4'
                  placeholder='Age'
                  name='age'
                  onChange={handleChangeUser}
                  value={signUp.age}
                />
                <label htmlFor='floatingInput4'>Age</label>
              </div>
              <div className='form-floating mb-3'>
                <input
                  type='password'
                  className='form-control rounded-4'
                  id='floatingPassword5'
                  placeholder='Password'
                  name='password'
                  onChange={handleChangeUser}
                  value={signUp.password}
                  required
                />
                <label htmlFor='floatingPassword5'>Password</label>
              </div>
              <div className='form-floating mb-3'>
                <input
                  type='password'
                  className='form-control rounded-4'
                  id='floatingPassword6'
                  placeholder='confirmPassword'
                  name='confirmPassword'
                  onChange={handleChangeUser}
                  value={signUp.confirmPassword}
                  required
                />
                <label htmlFor='floatingPassword6'>Confim Password</label>
              </div>
              <button className='w-100 mb-2 btn btn-lg rounded-4 btn-primary' type='submit' onClick={handleSubmitUser}>
                Sign up
              </button>
              <hr className='my-3' />
              <p className='text-center'>
                if You have an Account ? Please <Link to='/login'>Login</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
